module.exports = __webpack_public_path__ + "img/1507242264.6ac7786c.jpg";